/**
 * App-wide constants.
 * Prefer enums or const objects over magic strings/numbers.
 */
export const APP_NAME = 'Acie Admin';
// React Query cache keys. Each entry is the root of a key; features compose
// further segments off it (e.g. [...QUERY_KEYS.scans, 'all', { limit }]).
export const QUERY_KEYS = {
    scans: ['scans'],
};
